__turbopack_context__.v({
  "abstract": "typography-module-scss-module__uBRjea__abstract",
  "body": "typography-module-scss-module__uBRjea__body",
  "caption": "typography-module-scss-module__uBRjea__caption",
  "captionMuted": "typography-module-scss-module__uBRjea__captionMuted",
  "error": "typography-module-scss-module__uBRjea__error",
  "h1": "typography-module-scss-module__uBRjea__h1",
  "h2": "typography-module-scss-module__uBRjea__h2",
  "h3": "typography-module-scss-module__uBRjea__h3",
  "h4": "typography-module-scss-module__uBRjea__h4",
  "h5": "typography-module-scss-module__uBRjea__h5",
  "h6": "typography-module-scss-module__uBRjea__h6",
  "label": "typography-module-scss-module__uBRjea__label",
  "link": "typography-module-scss-module__uBRjea__link",
  "muted": "typography-module-scss-module__uBRjea__muted",
  "quote": "typography-module-scss-module__uBRjea__quote",
  "success": "typography-module-scss-module__uBRjea__success",
});
